import { useState, useCallback, useEffect } from 'react'
import { api } from '../api/client.js'

export interface Branch {
  id: string
  name: string
  location_id?: string
}

export interface UseBranchesResult {
  branches: Branch[]
  loading: boolean
  error: string | null
  refetch: (locationId?: string) => Promise<void>
}

export function useBranches(locationId?: string): UseBranchesResult {
  const [branches, setBranches] = useState<Branch[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async (currentLocationId?: string): Promise<void> => {
    setLoading(true)
    setError(null)
    try {
      const url = currentLocationId ? `/branches/dropdown?location_id=${currentLocationId}` : '/branches/dropdown'
      console.log('Fetching branches from:', url)
      const res = await api.get<{ branches: Branch[] }>(url)
      console.log('Branches response:', res)
      setBranches(res.branches || [])
    } catch (e) {
      console.error('Failed to fetch branches:', e)
      setError(e instanceof Error ? e.message : 'Failed to fetch branches')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void refetch(locationId)
  }, [locationId, refetch])

  return { branches, loading, error, refetch }
}
